var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6997",
    "data-name": "Rectangle 6997",
    width: 48,
    height: 48,
    transform: "translate(0 -0.618)",
    fill: "#e6e8f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_online_transactions_password",
    "data-name": "Change online transactions password",
    transform: "translate(0 0.618)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27804",
    "data-name": "Group 27804",
    transform: "translate(9.081 8.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27803",
    "data-name": "Group 27803",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27789",
    "data-name": "Group 27789",
    transform: "translate(0 15.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30901",
    "data-name": "Path 30901",
    d: "M95.618,180.862H89.272a14.541,14.541,0,0,0,1.573,5.821h5.432A30.888,30.888,0,0,1,95.618,180.862Z",
    transform: "translate(-89.272 -180.862)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27790",
    "data-name": "Group 27790",
    transform: "translate(2.542 23.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30902",
    "data-name": "Path 30902",
    d: "M92.405,190.214A15.092,15.092,0,0,0,99.3,195.7a32.181,32.181,0,0,1-2.032-5.483Z",
    transform: "translate(-92.405 -190.214)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27791",
    "data-name": "Group 27791",
    transform: "translate(9.231 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30903",
    "data-name": "Path 30903",
    d: "M100.709,167.8h4.954v-6.531a15.386,15.386,0,0,0-2.277.293A30.85,30.85,0,0,0,100.709,167.8Z",
    transform: "translate(-100.709 -161.268)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27792",
    "data-name": "Group 27792",
    transform: "translate(15.815 23.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30904",
    "data-name": "Path 30904",
    d: "M113.969,190.214h-5.1v6.531a15.23,15.23,0,0,0,2.593-.365A30.736,30.736,0,0,0,113.969,190.214Z",
    transform: "translate(-108.866 -190.214)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27793",
    "data-name": "Group 27793",
    transform: "translate(2.542 0.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30905",
    "data-name": "Path 30905",
    d: "M99.6,162.437a15.09,15.09,0,0,0-7.193,5.6h5A32.2,32.2,0,0,1,99.6,162.437Z",
    transform: "translate(-92.405 -162.437)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27794",
    "data-name": "Group 27794",
    transform: "translate(15.816 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30906",
    "data-name": "Path 30906",
    d: "M108.866,167.8h4.954a30.806,30.806,0,0,0-2.678-6.238,15.354,15.354,0,0,0-2.276-.293Z",
    transform: "translate(-108.866 -161.269)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27795",
    "data-name": "Group 27795",
    transform: "translate(20.266 0.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30907",
    "data-name": "Path 30907",
    d: "M121.6,168.036a15.089,15.089,0,0,0-7.192-5.6,32.327,32.327,0,0,1,2.192,5.6Z",
    transform: "translate(-114.41 -162.437)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27796",
    "data-name": "Group 27796",
    transform: "translate(0 8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30908",
    "data-name": "Path 30908",
    d: "M96.4,171.51h-5.55a14.548,14.548,0,0,0-1.573,5.821h6.357A30.887,30.887,0,0,1,96.4,171.51Z",
    transform: "translate(-89.272 -171.51)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27797",
    "data-name": "Group 27797",
    transform: "translate(9.083 23.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30909",
    "data-name": "Path 30909",
    d: "M105.628,190.214h-5.1a30.733,30.733,0,0,0,2.509,6.165,15.251,15.251,0,0,0,2.594.365Z",
    transform: "translate(-100.525 -190.214)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27798",
    "data-name": "Group 27798",
    transform: "translate(7.985 8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30910",
    "data-name": "Path 30910",
    d: "M99.167,177.331h6.2V171.51h-5.4A29.408,29.408,0,0,0,99.167,177.331Z",
    transform: "translate(-99.167 -171.51)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27799",
    "data-name": "Group 27799",
    transform: "translate(15.811 8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30911",
    "data-name": "Path 30911",
    d: "M114.264,171.51h-5.4v5.821h6.2A29.288,29.288,0,0,0,114.264,171.51Z",
    transform: "translate(-108.866 -171.51)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27800",
    "data-name": "Group 27800",
    transform: "translate(7.974 15.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30912",
    "data-name": "Path 30912",
    d: "M99.853,186.683h5.517v-5.821H99.154A29.332,29.332,0,0,0,99.853,186.683Z",
    transform: "translate(-99.154 -180.862)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27801",
    "data-name": "Group 27801",
    transform: "translate(20.567 23.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30913",
    "data-name": "Path 30913",
    d: "M114.781,195.7a15.094,15.094,0,0,0,6.891-5.483h-4.86A32.11,32.11,0,0,1,114.781,195.7Z",
    transform: "translate(-114.781 -190.214)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27802",
    "data-name": "Group 27802",
    transform: "translate(22.877 8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30914",
    "data-name": "Path 30914",
    d: "M117.628,171.51a30.888,30.888,0,0,1,.767,5.821h6.357a14.534,14.534,0,0,0-1.573-5.821Z",
    transform: "translate(-117.628 -171.51)",
    fill: "#3d72fc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_30915",
    "data-name": "Path 30915",
    d: "M5.418-6.42,4.145-7.255,4.172-5.8H2.83l.027-1.452L1.569-6.42.843-7.611l1.411-.863-1.438-.9.74-1.164,1.3.849L2.83-11.2H4.172L4.145-9.68l1.3-.863L6.2-9.378l-1.438.9,1.411.863Z",
    transform: "translate(15.211 27.107)",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30916",
    "data-name": "Path 30916",
    d: "M5.418-6.42,4.145-7.255,4.172-5.8H2.83l.027-1.452L1.569-6.42.843-7.611l1.411-.863-1.438-.9.74-1.164,1.3.849L2.83-11.2H4.172L4.145-9.68l1.3-.863L6.2-9.378l-1.438.9,1.411.863Z",
    transform: "translate(21.427 27.107)",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30917",
    "data-name": "Path 30917",
    d: "M5.418-6.42,4.145-7.255,4.172-5.8H2.83l.027-1.452L1.569-6.42.843-7.611l1.411-.863-1.438-.9.74-1.164,1.3.849L2.83-11.2H4.172L4.145-9.68l1.3-.863L6.2-9.378l-1.438.9,1.411.863Z",
    transform: "translate(27.642 27.107)",
    fill: "#ffb063"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.40556f5f3032aaeba00ead6e24dfaa34.svg";
export { ForwardRef as ReactComponent };